import React, { useState, useEffect, useRef } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import axios from "../../../../api/axios";

import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import { FormGroup, Typography } from "@mui/material";
import Divider from "@mui/material/Divider";

import AddIcon from "@mui/icons-material/Add";
import ContentCopy from "@mui/icons-material/ContentCopy";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/DeleteOutlined";
import SaveIcon from "@mui/icons-material/Save";
import CancelIcon from "@mui/icons-material/Close";
import Stack from "@mui/material/Stack";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";

import "./admin_acgtcards.css";

import {
  GridRowModes,
  DataGrid,
  GridToolbarContainer,
  GridActionsCellItem,
  GridRowEditStopReasons,
} from "@mui/x-data-grid";
import { useLocation } from "react-router-dom";
import { url } from "../../../../configlink";

//import ACGTCardPaymentViewDlg from "./ACGTCardPaymentViewDlg";

export default function ACGTCardPaymentHistory() {
  const [paymentHistoryRows, setPaymentHistoryRows] = useState([]);

  const [rowModesModel, setRowModesModel] = React.useState({});

  const [anchorEl, setAnchorEl] = useState(null);
  const [openDialogName, setOpenDialog] = useState(null);

  const [userId, setUserId] = useState(0);

  const paymentId = useRef();

  const [acgtCardPaymentView, setACGTCardPaymentView] = useState([]);

  const handleClose = () => {
    setAnchorEl(null);
  };

  const getACGTCardPaymentView = async (data) => {
    try {
      const response = await axios.get(
        `${url}/api/admin/get_admin_acgtcard_payment_view`,
        {
          params: {
            paymentId: data,
          },
          withCredentials: true,
        }
      );
      //   alert("acgtcard=" + response.data[0].acgtCardNumber);
      setACGTCardPaymentView(response.data);
    } catch (error) {
      console.error(error);
    }
  };

  const handleEditClick = (id) => {
    // getACGTCardPaymentView(id);
    // paymentId.current = id;

    // setOpenDialog("acgtcard_payment_view_dlg");
    // openDialog();

    const url = `/editacgtcardpayments?id=${id}`;
    const width = 650;
    const height = 800;

    const left = 100;
    const top = 100;

    window.open(
      url,
      "_blank",
      `width=${width},height=${height},left=${left},top=${top},scrollbars=yes,resizable=yes`
    );
  };

  const handleAddClick = () => {
    const url = `/editacgtcardpayments`;
    const width = 650;
    const height = 800;

    const left = 100;
    const top = 100;

    window.open(
      url,
      "_blank",
      `width=${width},height=${height},left=${left},top=${top},scrollbars=yes,resizable=yes`
    );
  };

  const closeDialog = () => {
    setOpenDialog(null);
    paymentId.current = 0;
  };

  const openDialog = () => {
    alert("OpenDialog =======>    " + userId);
    /*alert('Selected Userid====' + userId);
    switch (openDialogName) {
      case 1:
        setOpenDialog(openDialogName);
        handleClose();
    }*/
  };

  let loc = useLocation();
  let [acgtcardData, setACGTCardData] = useState([]);

  useEffect(() => {
    let data = loc.search.split("=")[1];
    console.log(data);
    getAcgtcardDetals(data);
  }, []);

  async function getAcgtcardDetals(x) {
    try {
      const response = await axios.get(
        `${url}/api/admin/get_admin_acgtcard_edit_detail`,{
          params: {
            id: x,
          },
          withCredentials: true,
        }
      );
      console.log(response.data);
      let card = response.data[0];
      setACGTCardData(card);
    } catch (error) {
      console.error(error);
    }
  }

  useEffect(() => {
    if (acgtcardData) {
      console.log(acgtcardData);

      getPaymentHistoryData();
    }
  }, [acgtcardData]);

  const getPaymentHistoryData = async () => {
    // alert("userId==" + acgtcardData.UserId);
    try {
      const response = await axios.get(
        `${url}/api/admin/get_acgtcard_payment_history`,
        {
          params: { userId: acgtcardData.UserId },
          withCredentials: true,
        }
      );
      console.log(response.data);
      setPaymentHistoryRows(response.data);
    } catch (error) {
      console.error(error);
    }
  };

  const columns = [
    { field: "id", headerName: "id", type: "text", hide: false },
    {
      field: "CardNumber",
      headerName: "CardNumber",
      type: "string",
      width: 180,
      editable: false,
    },
    {
      field: "pdate",
      headerName: "Date",
      type: "string",
      width: 100,
      editable: false,
    },
    {
      field: "stype",
      headerName: "Type",
      type: "string",
      width: 120,
      editable: false,
    },
    {
      field: "FirstName",
      headerName: "FirstName",
      type: "string",
      width: 100,
      editable: false,
    },
    {
      field: "LastName",
      headerName: "LastName",
      type: "string",
      width: 100,
      editable: false,
    },
    {
      field: "Amount",
      headerName: "Amount",
      type: "string",
      width: 70,
      editable: false,
    },
    {
      field: "sstatus",
      headerName: "Status",
      type: "string",
      width: 70,
      editable: false,
    },

    {
      field: "actions",
      type: "actions",
      headerName: "Actions",
      width: 100,
      cellClassName: "actions",
      getActions: ({ id }) => {
        return [
          <GridActionsCellItem
            icon={<EditIcon />}
            label="Edit"
            className="textPrimary"
            key={id}
            onClick={() => handleEditClick(id)}
            color="inherit"
          />,
        ];
      },
    },
  ];

  const [isOpened, setIsOpened] = useState(false);

  return (
    <div>
      <div>
        <div className="App">
          <div style={{ padding: 20, paddingBottom: 10 }}>
            <Typography
              variant="h5"
              style={{
                fontWeight: "bold",
                color: "var(--color-primary-purple)",
              }}
              align="Center"
            >
              ACGT Card Payment History
            </Typography>
            <Divider
              style={{
                marginTop: 10,
                marginBottom: 30,
                marginLeft: 20,
                marginRight: 20,
              }}
            />
          </div>

          <div className="flex justify-end mx-[20px] mb-[20px]">
            <button
              onClick={() => handleAddClick()}
              className="px-4 py-1 text-white text-[13px] bg-[var(--color-primary-purple)] rounded-md"
            >
              Add
            </button>
          </div>

          <div className="container2">
            <main className="main2">
              <DataGrid
                style={{ width: "100%", height: "95%" }}
                columnHeaderHeight={35}
                rowHeight={40}
                rows={paymentHistoryRows}
                columns={columns}
                sx={{
                  "& .MuiDataGrid-columnHeaders": {
                    color: "var(--color-primary-purple)",
                  },
                  "& .MuiDataGrid-columnHeaderTitle": {
                    fontWeight: 700,
                  },
                }}
                pageSize={15}
              />
            </main>
          </div>
        </div>
      </div>
    </div>
  );
}
